import React from 'react'
import PropTypes from 'prop-types'
import StoreForm from '../form/StoreForm';
import withLayout from "../../../layout/withLayout";
import {lifecycle} from "recompose";

const EditStore = (props) => {
    return(
        <StoreForm {...props}/>
    )
}

EditStore.propTypes = {
    storeId: PropTypes.string.isRequired,
    findStore: PropTypes.func.isRequired,
    clearState: PropTypes.func.isRequired
}

export default lifecycle({
    componentDidMount() {
        this.props.clearState()
        this.props.findStore(this.props.storeId)
    }
})(withLayout(EditStore))



// WEBPACK FOOTER //
// ./src/modules/store/component/edit/EditStore.js